<template>
  <div id="breadcrumb">
      <div :class="stepCount >= index ? 'active': 'inactive'"
           :style="`color: ${corPrimaria}`"
           v-for="(template, index) in steps" :key="index">
        <div v-if="template.titulo">
          <span>{{template.titulo}}</span>
          <i v-if="index + 1 < steps.length" class="el-icon-arrow-right separator"></i>
        </div>
        <div :class="stepCount >= index ? 'progress-line': ''"></div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'template-steps',
  props: {
    corPrimaria: {},
    stepCount: {},
    steps: {}
  }
}
</script>
<style lang="less">
#breadcrumb {
  padding: 12px 20px;
  display: flex;
  border-bottom: 1px solid #eeeeee;
  .active {
    opacity: 1;
  }

  .inactive {
    opacity: 0.5;
  }

  .el-breadcrumb__inner {
    color: unset;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: unset;
  }

  .el-breadcrumb__separator {
    color: unset;
  }
  .progress-line {
    border-bottom: 2px solid #E8AA27;
    position: relative;
    top: 13px;
  }
  .separator {
    padding: 4px;
  }
}
</style>
